<template>
	<div>

	<el-row class="container">
		<el-col :span="24" class="header">			
			<el-col :span="10" class="logo" :class="collapsed?'logo-collapse-width':'logo-width'">
				{{collapsed?'':sysName}}
			</el-col>
			<!-- 中间小一些，放未读通知 -->
			<el-col :span="4">
				
			</el-col>
			<el-col :span="10" class="userinfo">
				<span v-if="unreadCount!=0" style="margin-right: 10px;color: white;">未读通知<el-badge :max="99"  :value="unreadCount" /></span>
				<el-dropdown trigger="hover">
					<span class="el-dropdown-link userinfo-inner">{{sysUserName}}</span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item @click.native="handleModify">修改密码</el-dropdown-item> 
						<el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</el-col>
		</el-col>
		<el-col :span="24" class="main">
			<aside :class="collapsed?'menu-collapsed':'menu-expanded'">
				<!--导航菜单-->
				<el-menu :default-active="$route.path" class="el-menu-vertical-demo" @open="handleopen" @close="handleclose" @select="handleselect"
					 unique-opened router v-show="!collapsed">
					<template v-for="(item,index) in $router.options.routes" v-if="!item.hidden">
						<el-submenu :index="index+''" v-if="!item.leaf">
							<template slot="title"><i :class="item.iconCls"></i>{{item.name}}</template>
							<el-menu-item v-for="child in item.children" :index="child.path" :key="child.path" v-if="!child.hidden">{{child.name}}</el-menu-item>
						</el-submenu>
						<el-menu-item v-if="item.leaf&&item.children.length>0" :index="item.children[0].path"><i :class="item.iconCls"></i>{{item.children[0].name}}</el-menu-item>
					</template>
				</el-menu>
				<!--导航菜单-折叠后-->
				<ul class="el-menu el-menu-vertical-demo collapsed" v-show="collapsed" ref="menuCollapsed">
					<li v-for="(item,index) in $router.options.routes" v-if="!item.hidden" class="el-submenu item">
						<template v-if="!item.leaf">
							<div class="el-submenu__title" style="padding-left: 20px;" @mouseover="showMenu(index,true)" @mouseout="showMenu(index,false)"><i :class="item.iconCls"></i></div>
							<ul class="el-menu submenu" :class="'submenu-hook-'+index" @mouseover="showMenu(index,true)" @mouseout="showMenu(index,false)"> 
								<li v-for="child in item.children" v-if="!child.hidden" :key="child.path" class="el-menu-item" style="padding-left: 40px;" :class="$route.path==child.path?'is-active':''" @click="$router.push(child.path)">{{child.name}}</li>
							</ul>
						</template>
						<template v-else>
							<li class="el-submenu">
								<div class="el-submenu__title el-menu-item" style="padding-left: 20px;height: 56px;line-height: 56px;padding: 0 20px;" :class="$route.path==item.children[0].path?'is-active':''" @click="$router.push(item.children[0].path)"><i :class="item.iconCls"></i></div>
							</li>
						</template>
					</li>
				</ul>
			</aside>
			<section class="content-container">
				<div class="grid-content bg-purple-light">
					<el-col :span="24" class="breadcrumb-container">
						<strong class="title">{{$route.name}}</strong>
						<el-breadcrumb separator="/" class="breadcrumb-inner">
							<el-breadcrumb-item v-for="item in $route.matched" :key="item.path">
								{{ item.name }}
							</el-breadcrumb-item>
						</el-breadcrumb>
					</el-col>
					<el-col :span="24" class="content-wrapper">
						<transition name="fade" mode="out-in">
							<router-view></router-view>
						</transition>
					</el-col>
				</div>
			</section>
		</el-col>
	</el-row>

	<!--修改密码界面-->
	<el-dialog title="修改密码" v-model="changeFormVisible" :close-on-click-modal="false">
		<el-form :model="changeForm" label-width="100px" :rules="changeFormRules" ref="changeForm">
			<el-form-item label="原密码" prop="oldpassword">
				<el-input v-model="changeForm.oldpassword" auto-complete="off"></el-input>
			</el-form-item>
		</el-form>
		<el-form :model="changeForm" label-width="100px" :rules="changeFormRules" ref="changeForm">
			<el-form-item label="新密码" prop="newpassword">
				<el-input v-model="changeForm.newpassword" auto-complete="off"></el-input>
			</el-form-item>
		</el-form>
		<el-form :model="changeForm" label-width="100px" :rules="changeFormRules" ref="changeForm">
			<el-form-item label="确认新密码" prop="newpassword2">
				<el-input v-model="changeForm.newpassword2" auto-complete="off"></el-input>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click.native="changeFormVisible = false">取消</el-button>
			<el-button type="primary" @click.native="changePwd" :loading="changeLoading">修改密码</el-button>
		</div>
	</el-dialog>

	

   
	</div>
</template>

<script>
	import { changePwd } from '../api/api';
	import { notificationState, fetchUnreadCount  } from '../common/js/notificationState';

	export default {
		data() {
			return {
				sysName:'宜春邮政快递业安全监管系统',

				objectId:0, //用户表id，改密码用

				collapsed:false,
				sysUserName: '',

				//修改密码界面
				changeFormVisible: false,//界面是否显示
				changeLoading: false,
				changeFormRules: {
					oldpassword: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
					newpassword: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
					newpassword2: [{ required: true, message: '请再次输入新密码', trigger: 'blur' }]
				},
	
				changeForm: {
					oldpassword: '',
					newpassword:'',
					newpassword2:'',
				},

				//未读通知数目
				showcnt:false,
				unreadcnt:0

			}
		},
		methods: {
			onSubmit() {
			},
			handleopen() {
			},
			handleclose() {
			},
			handleselect: function (a, b) {
			},

			// 修改密码
			handleModify: function () {
				this.changeFormVisible = true;
				this.changeForm={
					oldpassword: '',
					newpassword:'',
					newpassword2:'',
				};
			},
			
			changePwd: function () {
				this.$refs.changeForm.validate((valid) => {
					if (valid) {
						if(this.changeForm.newpassword!=this.changeForm.newpassword2){
							this.$message.error("两次输入的新密码不一致");
						}
						else{
							this.$confirm('确认修改吗？', '提示', {}).then(() => {
								this.changeLoading = true;
								let para = {
									userId: this.objectId,
									oldPwd:this.changeForm.oldpassword,
									pwd:this.changeForm.newpassword
								};

								changePwd(para).then((res) => {
									this.changeLoading = false;
									this.changeFormVisible = false;
									if(res.data.code==0){
										this.$message.success(res.data.message);
									}
									else{
										this.$message.error(res.data.message);
									}
								});
							});
						}
					}
				});
			},
			//退出登录
			logout: function () {
				var _this = this;
				this.$confirm('确认退出吗?', '提示', {
					//type: 'warning'
				}).then(() => {
					sessionStorage.removeItem('user');
					_this.$router.push('/login');
				}).catch(() => {

				});
			},
			//折叠导航栏
			collapse:function(){
				this.collapsed=!this.collapsed;
			},
			showMenu(i,status){
				this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-'+i)[0].style.display=status?'block':'none';
			}
		},
		computed: {
			unreadCount() {
			return notificationState.unreadCount // 响应式获取
			}
		},
		mounted() {
			var user = sessionStorage.getItem('user');
			if (user) {
				user = JSON.parse(user);
				this.objectId = user.data.userId
				this.sysUserName = user.data.userName || '';
			}
			fetchUnreadCount() //未读通知数
			let  routes = this.$router.options.routes;

			//企业用户，只显示：基础管理3，隐患排查4，监督检查-检查记录 5-0 5-1，通知管理6
			if(user.data.roleId =='4'){
				for (let index = 3; index < routes.length; index++) {
					const element = routes[index];
					if (index==3||index==4||index==5||index==6) {
						element.hidden = false;  
						let  curroute = this.$router.options.routes[index].children;
						for (let index2 = 0; index2 < curroute.length; index2++) {
							const element2 = curroute[index2];
							if (index==5) {
								if (index2!=0||index2!=1) {
									element2.hidden = false; 
								}
								else{
									element2.hidden = true; 
								}
							}
							else{
								element2.hidden = false; 
							}
						}
					} else {
						element.hidden = true; 
					}
				}
			}
			else{
				//去掉默认的前3个，显示全部菜单
				for (let index = 3; index < routes.length; index++) {
					const element = routes[index];
					element.hidden = false;  
				
					let  curroute = element.children;
					for (let index2 = 0; index2 < curroute.length; index2++) {
						const element2 = curroute[index2];
						element2.hidden = false; 
					}
				}
				//协议客户管理3-3，不显示 2025-11-25 也显示，栏目有差异 2026-03-20会议
				// let  newroute = this.$router.options.routes[3].children;
				// const newelement2 = newroute[3];
				// newelement2.hidden = true; 
			}
			
		}
	}

</script>

<style scoped lang="scss">
	@import '~scss_vars';
	
	.container {
		position: absolute;
		top: 0px;
		bottom: 0px;
		width: 100%;
		.header {
			height: 60px;
			line-height: 60px;
			background: $color-primary;
			color:#fff;
			.userinfo {
				text-align: right;
				padding-right: 20px;
				float: right;
				.userinfo-inner {
					cursor: pointer;
					color:#fff;
					img {
						width: 40px;
						height: 40px;
						border-radius: 20px;
						margin: 10px 0px 10px 10px;
						float: right;
					}
				}
			}
			.logo {
				//width:230px;
				height:60px;
				font-size: 16px;
				padding-left:10px;
				padding-right:10px;
				border-color: rgba(238,241,146,0.3);
				border-right-width: 1px;
				border-right-style: solid;
				img {
					width: 40px;
					float: left;
					margin: 10px 10px 10px 18px;
				}
				.txt {
					color:#fff;
				}
			}
			.logo-width{
				width:230px;
			}
			.logo-collapse-width{
				width:60px
			}
			.tools{
				padding: 0px 23px;
				width:14px;
				height: 60px;
				line-height: 60px;
				cursor: pointer;
			}
		}
		.main {
			display: flex;
			// background: #324057;
			position: absolute;
			top: 60px;
			bottom: 0px;
			overflow: hidden;
			aside {
				flex:0 0 230px;
				width: 230px;
				// position: absolute;
				// top: 0px;
				// bottom: 0px;
				.el-menu{
					height: 100%;
				}
				.collapsed{
					width:60px;
					.item{
						position: relative;
					}
					.submenu{
						position:absolute;
						top:0px;
						left:60px;
						z-index:99999;
						height:auto;
						display:none;
					}

				}
			}
			.menu-collapsed{
				flex:0 0 60px;
				width: 60px;
			}
			.menu-expanded{
				//展开二级菜单，可以滚动显示
				overflow-y: scroll;
				flex:0 0 230px;
				width: 230px;
			}
			.content-container {
				// background: #f1f2f7;
				flex:1;
				// position: absolute;
				// right: 0px;
				// top: 0px;
				// bottom: 0px;
				// left: 230px;
				overflow-y: scroll;
				padding: 20px;
				.breadcrumb-container {
					//margin-bottom: 15px;
					.title {
						width: 200px;
						float: left;
						color: #475669;
					}
					.breadcrumb-inner {
						float: right;
					}
				}
				.content-wrapper {
					background-color: #fff;
					box-sizing: border-box;
				}
			}
		}
	}

// 	#myfoot {
//     height: 50px;
//     line-height: 20px;
//     position: fixed;
//     bottom: 0;
//     width: 100%;
//     text-align: center;
//     // background: #333;
//     // color: #fff;
//     color: #333;
//     font-family: Arial;
//     font-size: 12px;
//     letter-spacing: 1px;
// }
</style>


// WEBPACK FOOTER //
// Home.vue?1a62c869